import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store' // Importa lo store per accedere a isAma

Vue.use(VueRouter)

import ListSection from './../components/ListSection.vue'
import SubListSection from './../components/SubListSection.vue'
import ProductDetail from './../components/ProductDetail.vue'
import Detail from './../components/Detail.vue'
import BannerSection from './../components/BannerSection.vue'
import StoneList from './../components/StoneList.vue'
import BuildYourJewel from './../components/BuildYourJewel.vue'

const originalPush = VueRouter.prototype.push
// Rewrite the push method on the prototype and handle the error message uniformly
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/banner',
      name: 'banner',
      component: BannerSection
    },
    {
      path: '/',
      name: 'list',
      component: ListSection,
    },
    {
      path: '/subList/:productType?/:typeId?',
      name: 'list.sublist',
      component: SubListSection,
      props: route => ({ section: route.query.section })
    },
    {
      path: '/detail/:sku/:direct?',
      name: 'list.detail',
      component: Detail
    },
    {
      path: '/product/detail/:sku/:kit?/:direct?',
      name: 'product.detail',
      component: ProductDetail
    },
    {
      path: '/results/stones',
      name: 'results.stones',
      component: StoneList
    },
    {
      path: '/build-your-jewel/:productType/:startFrom/:stonesNumber',
      name: 'build-your-jewel',
      component: BuildYourJewel
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'list') {
    let attempts = 0;

    const waitForIsReady = async () => {
      while (!store.getters["config/isReady"] && attempts < 50) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
    };

    await waitForIsReady();

    if (store.getters["config/isAma"]) {
      if (store.getters['detail/getPreselectedJewel'].sku) {
        return;
      } else {
        return next({
          name: "list.sublist",
          params: { productType: 'AMA_JEWELLERY' },
          query: { },
          replace: true
        });
      }
    }

    return next();
  }

  next();
});

export default router